import request from "axios";
import types from "./types";

import {
  receivedCampaigns,
  resetAndAddNewCampaigns,
  MINIMUM_WAIT_FOR_RESPONSE,
  WAIT_TO_SHOW_CONTENT,
} from "data/campaigns";

import handleProcessorErrors from "data/api/handle-processor-errors";

export const setAutoVote = (bool) => {
  return {
    type: types.SET_AUTO_VOTE,
    payload: {
      autoVote: bool,
    },
  };
};

export const setVotes = (campaign, votes) => {
  return {
    type: types.SET_VOTES,
    campaign,
    votes,
  };
};

export const addCampaign = (campaign) => {
  return {
    type: types.ADD_CAMPAIGN,
    campaign,
  };
};

export const removeCampaign = (campaign) => {
  return {
    type: types.REMOVE_CAMPAIGN,
    campaign,
  };
};

export const selectCampaign = (campaign, bool) => {
  return (dispatch) => {
    if (bool === true) {
      return dispatch(addCampaign(campaign));
    }

    return dispatch(removeCampaign(campaign));
  };
};

export const resetSearchFilters = () => {
  return {
    type: types.RESET_SEARCH_FILTERS,
  };
};

export const resetSelectedVotes = (totalVotes) => {
  return {
    type: types.RESET_SELECTED_VOTES,
    totalVotes,
  };
};

export const selectCategory = (category) => {
  return {
    type: types.SET_PARENT_CATEGORY,
    category,
  };
};

export const setQuery = (query) => {
  return {
    type: types.SET_QUERY,
    query,
  };
};

export const toggleLoading = () => {
  return {
    type: types.TOGGLE_LOADING,
  };
};

export const togglePaginationLoad = () => {
  return {
    type: types.TOGGLE_PAGINATION_LOAD,
  };
};

export const setCampaignThatLaunchedForm = (id) => {
  return {
    type: types.SET_CAMPAIGN,
    id,
  };
};

export const setValidating = (bool) => {
  return {
    type: types.SET_VALIDATING,
    payload: {
      validating: bool,
    },
  };
};

export const setInitialVotes = (votes) => {
  return {
    type: types.SET_INITIAL_VOTES,
    votes,
  };
};

export const setUserId = (id) => {
  return {
    type: types.SET_USER_ID,
    id,
  };
};

export const submitError = (error) => {
  return {
    type: types.SUBMIT_ERROR,
    error,
  };
};

export const setDonationId = (id) => {
  return {
    type: types.SET_DONATION_ID,
    payload: { id },
  };
};

const formatValues = (campaignId, valuesFromForm, spreedlyToken) => {
  const values = Object.assign({}, valuesFromForm);

  if (values.month && values.year && values.card_exp) {
    delete values.card_exp;
    delete values.month;
    delete values.year;
  }

  if (values.isPublic === true || values.isPublic === false) {
    values.public = values.isPublic;
    delete values.isPublic;
  }

  values.campaign_id = campaignId;
  values.spreedly_cc_token = spreedlyToken;

  if (values.custom_fields_hash) {
    values.custom_fields_hash = JSON.stringify(values.custom_fields_hash);
  }

  return values;
};

export const submitVotingForm = (campaignId, dispatch, values, spreedlyToken) => {
  if (!campaignId) {
    throw new Error("Must supply a campaign id");
  }

  const token = $('meta[name="csrf-token"]').attr("content");

  const data = {
    donation: formatValues(campaignId, values, spreedlyToken),
  };

  // Dead code: /donations routes to DonationsController#create, which does not exist.
  // Tracked for removal separately; see FUN-48139.
  const url = "/donations";

  dispatch(submitError(""));

  return request(url, {
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      "X-CSRF-Token": token,
    },
    method: "POST",
    data,
  })
    .then(({ data }) => {
      dispatch(setUserId(data.donation.constituent_id || data.donation.user_id));
      dispatch(setDonationId(data.donation.id));
      dispatch(setInitialVotes(data.donation.votes));
    })
    .catch(({ response }) => {
      const errors = response && response.data && response.data.errors;

      if (errors) {
        if (errors.base) {
          dispatch(submitError(errors.base));
        } else {
          dispatch(submitError("Error processing your donation"));
        }
        handleProcessorErrors(errors);

        dispatch(setValidating(false));
      } else {
        if (typeof response === "object") throw new Error(JSON.stringify(response));
        throw new Error(response);
      }
    });
};

export function buildUrl(dispatch, entity, options) {
  let buildableUrl = `/microsite/api/campaigns?entity_id=${entity}`;

  // scopes to campaigns belonging to a section
  if (options.sectionId) {
    buildableUrl += `&section_id=${options.sectionId}`;
  }

  // scopes to sibling campaigns of the campaign
  if (options.campaignId) {
    buildableUrl += `&campaign_id=${options.campaignId}`;
  }

  if (options.page || options.page >= 0) {
    buildableUrl += `&page=${options.page}`;
  }

  if (options.query) {
    buildableUrl += `&search=${options.query}`;
  }

  if (options.parentQuery) {
    buildableUrl += `&search=${options.parentQuery}`;
  }

  if (options.limit) {
    buildableUrl += `&limit=${options.limit}`;
  }

  if (options.category) {
    if (options.category !== "null" && options.category != "") {
      buildableUrl += `&category=${encodeURIComponent(options.category)}`;
    }
  }

  return buildableUrl;
}

export const searchCampaignsByEntity = (entity, options = {}) => {
  return (dispatch, getState) => {
    const { isPaginationLoad } = options;
    isPaginationLoad ? dispatch(togglePaginationLoad()) : dispatch(toggleLoading());

    const startTime = Date.now();

    const buildableUrl = buildUrl(dispatch, entity, options);

    return request(buildableUrl)
      .then((res) => {
        // dispatch actions after set timeout so the campaigns don't show
        // in the ui before the spinner is canceled
        const dispatchReceivedCampaigns = () => {
          if (options.resetCampaigns === true) {
            dispatch(
              resetAndAddNewCampaigns(res.data.campaigns, res.data.meta.total_campaigns),
            );
          } else {
            dispatch(
              receivedCampaigns(res.data.campaigns, res.data.meta.total_campaigns),
            );
          }
        };

        const endTime = Date.now();

        // toggle is loading to false if we have waited a long enough time
        // to make the ui more fluid
        if (endTime - startTime < MINIMUM_WAIT_FOR_RESPONSE) {
          const promise = new Promise((resolve) => {
            setTimeout(() => {
              dispatchReceivedCampaigns();
              isPaginationLoad
                ? dispatch(togglePaginationLoad())
                : dispatch(toggleLoading());

              resolve({
                offset: res.data.campaigns.length,
                total: res.data.meta.total_campaigns,
              });
            }, WAIT_TO_SHOW_CONTENT);
          });

          return promise.then((res) => res);
        }

        dispatchReceivedCampaigns();
        isPaginationLoad ? dispatch(togglePaginationLoad()) : dispatch(toggleLoading());

        return {
          total: res.data.meta.total_campaigns,
        };
      })
      .catch((err) => {
        const { res } = err;

        dispatch(errorReceivingCampaigns(res.data.errors));
        isPaginationLoad ? dispatch(togglePaginationLoad()) : dispatch(toggleLoading());
      });
  };
};

export const submitVotes = ({ donationId, userId, parentCampaignId, campaigns }) => {
  return (dispatch) => {
    dispatch(submitError());
    dispatch(toggleLoading());

    const url = "/cast_votes";
    const token = document.querySelector('meta[name="csrf-token"]').content;

    const formattedObject = {};
    const formattedCampaigns = {};

    campaigns.map((campaign) => {
      const id = campaign.get("id");
      const votes = campaign.get("votes");

      formattedCampaigns[id] = votes;
    });

    formattedObject.donation_id = donationId;
    formattedObject.constituent_id = userId;
    formattedObject.parent_campaign_id = parentCampaignId;
    formattedObject.campaigns_votes_hash = formattedCampaigns;

    return request(url, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        "X-CSRF-Token": token,
      },
      method: "POST",
      data: formattedObject,
    })
      .then(() => {
        dispatch(toggleLoading());
      })
      .catch((err) => {
        const { res } = err;

        dispatch(toggleLoading());

        if (res) {
          dispatch(submitError(res.data.errors));
        } else {
          dispatch(submitError("Error processing your votes"));
          throw err;
        }
      });
  };
};
